import { isNotStringAndIterable } from "@thi.ng/checks";
import { flattenWith } from "./flatten-with";
export function flatten(src) {
    return flattenWith((x) => (isNotStringAndIterable(x) ? x : undefined), src);
}
